import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";

export default function useQuoteCalculate() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const calculate = useMutation({
    mutationFn: (quote: any) => post("/quote/calculate", quote),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["quotes", "calculated"] });
    }
  });

  return {
    calculate,
  }
}